module.exports = __webpack_public_path__ + "static/media/arquitect_10.eb63029d.jpeg";